import * as React from "react";
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.545}
        d="m1 20.78 4.396-4.396m0 0L20.78 1l15.384 15.384m-30.768 0v21.978c0 1.214.983 2.198 2.197 2.198h6.594m21.977-24.176 4.396 4.396m-4.396-4.396v21.978a2.198 2.198 0 0 1-2.198 2.198h-6.593m-13.187 0a2.198 2.198 0 0 0 2.198-2.198V29.57c0-1.214.984-2.198 2.198-2.198h4.395c1.214 0 2.198.984 2.198 2.198v8.79c0 1.215.984 2.199 2.198 2.199m-13.187 0h13.187"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
